import { z } from 'zod'

export const PromotionTriggerSourceSchema = z.enum(['order_paid', 'subscription_rebill'])

export const PromotionTriggerCustomerRestrictionTypeSchema = z.enum([
    'customer_id',
    'email_pattern',
])

export const PromotionTriggerSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    source: PromotionTriggerSourceSchema,
    promotionId: z.string(),
    productId: z.string(),
    storeId: z.string(),
    accountId: z.string(),
    codePrefix: z.string().nullable(),
    usageLimit: z.number().nullable(),
    expiresInDays: z.number().nullable(),
    customerRestrictionType: PromotionTriggerCustomerRestrictionTypeSchema,
    emailTemplateId: z.string().nullable(),
    enabled: z.boolean().default(true),
    createdAt: z.date(),
    updatedAt: z.date(),
})

export const PromotionTriggerWithProductSchema = PromotionTriggerSchema.extend({
    product: z.object({
        id: z.string(),
        name: z.string(),
        description: z.string().nullable(),
        active: z.boolean(),
    }),
})

export const PromotionTriggerWithPromotionSchema = PromotionTriggerSchema.extend({
    promotion: z.object({
        id: z.string(),
        name: z.string(),
        code: z.string().nullable(),
        automatic: z.boolean(),
    }),
})

export const PromotionTriggerWithRelationsSchema = PromotionTriggerSchema.extend({
    product: z.object({
        id: z.string(),
        name: z.string(),
        description: z.string().nullable(),
        active: z.boolean(),
    }),
    promotion: z.object({
        id: z.string(),
        name: z.string(),
        code: z.string().nullable(),
        automatic: z.boolean(),
    }),
})

export const PromotionTriggerListItemSchema = PromotionTriggerWithProductSchema

export const PromotionTriggerDetailsSchema = PromotionTriggerWithRelationsSchema

export type PromotionTriggerSourceType = z.infer<typeof PromotionTriggerSourceSchema>
export type PromotionTriggerCustomerRestrictionTypeType = z.infer<
    typeof PromotionTriggerCustomerRestrictionTypeSchema
>
export type PromotionTriggerType = z.infer<typeof PromotionTriggerSchema>
export type PromotionTriggerWithProductType = z.infer<typeof PromotionTriggerWithProductSchema>
export type PromotionTriggerWithPromotionType = z.infer<
    typeof PromotionTriggerWithPromotionSchema
>
export type PromotionTriggerWithRelationsType = z.infer<
    typeof PromotionTriggerWithRelationsSchema
>
export type PromotionTriggerListItemType = z.infer<typeof PromotionTriggerListItemSchema>
export type PromotionTriggerDetailsType = z.infer<typeof PromotionTriggerDetailsSchema>

export const toPromotionTriggerDto = (data: any): PromotionTriggerType => {
    return PromotionTriggerSchema.parse(data)
}

export const toPromotionTriggerWithProductDto = (
    data: any,
): PromotionTriggerWithProductType => {
    return PromotionTriggerWithProductSchema.parse(data)
}

export const toPromotionTriggerWithPromotionDto = (
    data: any,
): PromotionTriggerWithPromotionType => {
    return PromotionTriggerWithPromotionSchema.parse(data)
}

export const toPromotionTriggerWithRelationsDto = (
    data: any,
): PromotionTriggerWithRelationsType => {
    return PromotionTriggerWithRelationsSchema.parse(data)
}

export const toPromotionTriggerListItemDto = (data: any): PromotionTriggerListItemType => {
    return PromotionTriggerListItemSchema.parse(data)
}

export const toPromotionTriggerDetailsDto = (data: any): PromotionTriggerDetailsType => {
    return PromotionTriggerDetailsSchema.parse(data)
}

